import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import * as strings from '../../helpers/strings';
// importing Css
import '../../index.css';
const stationData = {
  StnSG: 'Singapore',
  StnML: 'Malaysia',
  StnViet: 'Vietnam',
};

const forecastRangeData = {
  '24/hr': '24/hr',
  '48/hr': '48/hr',
};

const forecastResolutionData = {
  '5"': '5"',
  '10"': '10"',
  '15"': '15"'
};

class ForecastStationSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStation: Object.keys(stationData)[0],
      selectedLocation: stationData[Object.keys(stationData)[0]],
      selectedRange: Object.keys(forecastRangeData)[0],
      selectedResolution: Object.keys(forecastResolutionData)[0],
    };
  }

  handleStationChange = (event) => {
    const selectedStation = event.target.value;
    this.setState({
      selectedStation,
      selectedLocation: stationData[selectedStation],
    });
  };

  handleRangeChange = (event) => {
    const selectedRange = event.target.value;
    this.setState({ selectedRange });
  };

  handleResolutionChange = (event) => {
    const selectedResolution = event.target.value;
    this.setState({ selectedResolution });
  };

  render() {
    const { selectedStation, selectedLocation, selectedRange, selectedResolution  } = this.state;

    return (
      <div className='ForcastFilters'>
        <div className='ForcastFilterStation'>
          <FormControl margin={strings.txtNormal}>
          <InputLabel className="filterLabelSelect">{strings.lblStation}</InputLabel>
          <Select id="stationSelect"  value={selectedStation} onChange={this.handleStationChange}>
            {Object.keys(stationData).map((station) => (
              <MenuItem key={station} value={station}>
                {station}
              </MenuItem>
            ))}
          </Select>
          {selectedLocation && (
            <p>Location: {selectedLocation}</p>
          )}
          </FormControl>
        </div>
        {/* <span className='VerticalDivider'></span> */}
        <div className='ForcastFilterRange'>
          <FormControl margin={strings.txtNormal}>
          <InputLabel className="filterLabelSelect" >{strings.lblRange}</InputLabel>
          <Select id="stationSelect" value={selectedRange} onChange={this.handleRangeChange}>
            {Object.keys(forecastRangeData).map((range) => (
              <MenuItem key={range} value={range}>
                {range}
              </MenuItem>
            ))}
          </Select>
          {selectedRange && (
            <p> Range: {selectedRange}</p>
          )}
          </FormControl>
        </div>
        {/* <span className='VerticalDivider'></span> */}
        <div className='ForcastFilterResolution'>
          <FormControl margin={strings.txtNormal}>
          <InputLabel className="filterLabelSelect" >{strings.lblForecastingResolution}</InputLabel>
          <Select id="stationSelect" value={selectedResolution} onChange={this.handleResolutionChange}>
            {Object.keys(forecastResolutionData).map((resolution) => (
              <MenuItem key={resolution} value={resolution}>
                {resolution}
              </MenuItem>
            ))}
          </Select>
          {selectedResolution && (
            <p>Resolution: {selectedResolution}</p>
          )}
          </FormControl>
        </div>
      </div>
    );
  }
}

export default ForecastStationSelect;
